import React from "react";
import { TextField } from "@mui/material";

interface IFormTextProps {
    autoFocus?: boolean;
    disabled?: boolean;
    fitToContainerHeight?: boolean;
    maxLength?: number;
    multiline?: boolean;
    name?: string;
    placeholder?: string;
    required?: boolean;
    rows?: number;
    tooltip: string;
    value: string;
    onChange: (value: string) => void;
}

export const FormText = (props: IFormTextProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const target = event.target;
        const value: string = target.value;
        props.onChange(value);
    };

    const textFieldSx = props.fitToContainerHeight
        ? {
            "flexGrow": 1,
            "display": "flex",
            "& .MuiInputBase-root": {
                "height": "100%",
                "alignItems": "start",
                "& textarea": {
                    overflowY: "auto!important",
                    height: "100%!important",
                }
            },
        }
        : undefined;

    return (
        <TextField
            autoFocus={props.autoFocus}
            disabled={props.disabled}
            fullWidth
            multiline={props.multiline}
            name={props.name}
            placeholder={props.placeholder}
            required={props.required}
            rows={!props.fitToContainerHeight
                ? (props.multiline
                    ? (props.rows ?? 3)
                    : undefined)
                : undefined}
            size="small"
            title={props.tooltip}
            value={props.value}
            inputProps={{
                maxLength: props.maxLength ?? 255
            }}
            onChange={handleChange}
            sx={textFieldSx}
        />
    );
};